/**
 * Master switch for Dentally PMS integration (UI + callable + Firestore trigger).
 * Set to true only when the integration is ready to ship and support again.
 */
export const DENTALLY_INTEGRATION_ENABLED = true;

/**
 * Master switch for the treatment-card layout on the new consent form.
 * On for every practice unless they opt out in Settings → Consent terms.
 * Set this to false to turn the cards off for every practice at once.
 */
export const TREATMENT_CARDS_AVAILABLE = true;

export function isTreatmentCardsEnabled(clinicData) {
  if (!TREATMENT_CARDS_AVAILABLE) return false;
  return clinicData?.consentFormFeatures?.treatmentCardsDisabled !== true;
}

/**
 * Facial aesthetics cards (Botox / filler) on the new consent form.
 * Separate from treatment cards so a practice can use one without the other.
 */
export const FACIAL_AESTHETICS_AVAILABLE = true;

export function isFacialAestheticsEnabled(clinicData) {
  return FACIAL_AESTHETICS_AVAILABLE && clinicData?.consentFormFeatures?.facialAesthetics === true;
}

/**
 * "Load from Dentally treatment plan" on the new consent form.
 * On for every practice that has Dentally connected.
 * Set DENTALLY_TREATMENT_PLAN_IMPORT_AVAILABLE to false to hide it everywhere.
 */
export const DENTALLY_TREATMENT_PLAN_IMPORT_AVAILABLE = true;

export function isDentallyTreatmentPlanImportEnabled() {
  return DENTALLY_INTEGRATION_ENABLED && DENTALLY_TREATMENT_PLAN_IMPORT_AVAILABLE;
}
